











































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { startCase } from 'lodash';
import { get } from 'vuex-pathify';

import {
  Configuration,
  IConfigurationItem
} from '@/models/configurator/configuration';

export default Vue.extend({
  data: () => ({
    headers: [
      {
        text: '',
        value: 'icons',
        sortable: false,
        width: 30
      },
      {
        text: '#',
        align: 'center',
        sortable: false,
        value: 'index'
      },
      {
        text: 'Item',
        sortable: false,
        value: 'item'
      },
      {
        text: 'Quantity',
        align: 'center',
        sortable: false,
        value: 'quantity'
      },
      {
        text: 'Description',
        align: 'left',
        sortable: false,
        value: 'description'
      }
    ],

    loading: false
  }),

  computed: {
    configurations: get<Configuration[]>(
      'configuratorConfiguration/configurations'
    ),

    items: get<IConfigurationItem[]>(
      'configuratorConfiguration/configurationItems'
    )
  },

  mounted() {
    this.loading = true;
    this.fetchConfigurationItems(this.$route.params.configurationId).finally(
      () => (this.loading = false)
    );
  },

  // items/
  methods: {
    startCase,

    ...mapActions('configuratorConfiguration', [
      'fetchConfiguration',
      'fetchConfigurationItems'
    ]),

    itemDetailClass(item: IConfigurationItem) {
      if (item.is_obsolete) {
        return 'item-row--disabled';
      }
    }
  }
});
